import addProfilePhoto from "../../../assets/images/uploadPicture.svg"
import close from "../../../assets/images/close.svg"

import { Modal } from "react-bootstrap";
import { useRef } from "react";
import QRCode from "react-qr-code";
import useStaffDetails from "./hooks/useStaffDetails";
import { useAuth } from "../../../context/auth-user";

export default function ViewStaff(props) {
	// VARIABLES RECIEVED FROM PROPS
	const { supplier, entitySelected, staffAssignmentId, onHide, handleSelectStaffPayroll } = props

	const { user } = useAuth()
    const darkLightMode = user?.selectedProfile?.darkLightMode

	const {
		data: staffToShow,
		staffModal,
		handleCloseModal,
		changeStaffPicture,
		removeStaffAssignmentHandler,
		isDeletingStaffAssignment
	} = useStaffDetails({
		supplier,
		staffAssignmentId,
		removeSelectedStaff: onHide
	})

	// REFERENCE TO CONTROL THE INPUT FILE FOR THE STAFF PROFILE PHOTO
	const staffPhotoRef = useRef(null)

	if (!staffToShow) return null

	const companyName = supplier?.informationCompliance?.generalInformation?.companyName || "N/A"


	// FUNCTION TO CONTROL THE FILE EXPLORER
	const handleOpenFileExplorer = () => {
		if (!staffPhotoRef.current)
			return

		staffPhotoRef.current.click()
	}

	// FUNCTION TO SAVE THE STAFF PROFILE PHOTO
	const handleInputPhotoChange = () => {
		const file = staffPhotoRef.current.files[0];

		if (!file) return;

		changeStaffPicture({ staffId: staffToShow._id, file, staffNSS: staffToShow.imss });

		staffPhotoRef.current.value = null
	}

	// FUNCTION TO DOWNLOAD THE QR CODE TO IMAGE (SVG)
	const downloadQR = (idQr) => {
		const qrCode = document.getElementById(idQr);

		const svgString = new XMLSerializer().serializeToString(qrCode)

		const blob = new Blob([svgString], { type: 'image/svg+xml' });
		const url = URL.createObjectURL(blob);

		const a = document.createElement('a');
		a.href = url;
		a.download = 'qrCode.svg';
		document.body.appendChild(a);
		a.click();

		document.body.removeChild(a);
		URL.revokeObjectURL(url);
	};

	const handleDeleteStaffAssignment = async () => {
		const result = await removeStaffAssignmentHandler({ assignmentId: staffAssignmentId });

		if (!result) return

		handleCloseModal()
		onHide()
	}

	const closeModal = () => {
		handleCloseModal()

		setTimeout(() => {
			onHide()
		}, 500)
	}

	return (
		<Modal
			className={`viewStaffModal ${darkLightMode ? "darkMode": ""}`}
			show={staffModal}
			onHide={closeModal}
			size="lg"
			centered>
			<Modal.Body>
				<img className="closeModal" src={close} onClick={closeModal} alt="Prodensa Supplier" />

				<QRCode id={staffToShow._id} className="qrCode" bgColor="transparent" size={256} viewBox="0 0 256 256"
					value={`{supplierId: ${supplier._id}, staffId: ${staffToShow._id}, entityId: ${entitySelected._id}}`} />

				<div className="staffResume">
					<input ref={staffPhotoRef} type="file" className="d-none" onChange={handleInputPhotoChange} />
					<img className="profilePhoto" onClick={handleOpenFileExplorer}
						src={staffToShow.profilePhoto?.document
							? process.env.REACT_APP_URI_LOCALHOST + staffToShow.profilePhoto.document
							: addProfilePhoto}
						alt="Prodensa Supplier"
					/>
					<div className="information">
						<span className="textInfo">Employee information</span>
						<span className="textTitle">{staffToShow.name}</span>
						<span className="textInfo">Name</span>
						<span className="textValue">{staffToShow.imss}</span>
						<span className="textInfo">IMSS</span>
						<span className="textValue">{staffToShow.curp}</span>
						<span className="textInfo">RFC/CURP</span>
						<span className="textValue">{companyName}</span>
						<span className="textInfo">Company name</span>
					</div>
				</div>

				<span className="downloadQR">Download employee QR Code <label>(SVG format)</label></span>

				<button className="btnBgBlueTextGradient" onClick={() => downloadQR(staffToShow._id)}>Download QR Code</button>

				{staffToShow.active && 
					<button 
						className="btnBgBlueTextGradient d-lg-none mt-2" 
						onClick={(e) => { 
							handleSelectStaffPayroll(e, staffAssignmentId); 
							closeModal(); 
						}}
					>
						View Documents
					</button>
				}

				<button 
					className="btnBgWhiteTextBlack d-lg-none mt-2"
					onClick={handleDeleteStaffAssignment}
					disabled={isDeletingStaffAssignment}
				>
					Delete
				</button>
			</Modal.Body>
		</Modal>
	)
}